import React from 'react';
import { FileText } from 'lucide-react';

const GenericPage = ({ title, description }) => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
      <p className="text-gray-600">{description}</p>
    </div>
    
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <div className="text-center py-12">
        <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
          <FileText className="w-8 h-8 text-gray-400" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">Content Coming Soon</h3>
        <p className="text-gray-600">This page is ready for your content and API integration.</p>
        <div className="mt-6 p-4 bg-gray-50 rounded-lg text-left">
          <p className="text-sm text-gray-700 font-medium mb-2">API Integration Ready:</p>
          <code className="text-xs text-gray-600 bg-white px-2 py-1 rounded">
            GET /api/v1/{title.toLowerCase().replace(' ', '-')}
          </code>
        </div>
      </div>
    </div>
  </div>
);

export default GenericPage;